<template>
  <div class="interactive-social-wall__feed">
    <div v-if="loadError"
         class="interactive-social-wall__feed-error"
         role="alert"
    >
      <span>{{ loadError }}</span>
      <button type="button" @click="$emit('retry')">{{ $t('general.try_again') }}</button>
    </div>

    <template v-if="!isLoaded">
      <article v-for="index in skeletonCount"
               :key="`interactive-social-wall-skeleton-${index}`"
               class="interactive-social-wall__post interactive-social-wall__post--skeleton"
      >
        <span class="interactive-social-wall__skeleton-avatar"/>
        <span class="interactive-social-wall__skeleton-content">
          <span class="interactive-social-wall__skeleton-title"/>
          <span class="interactive-social-wall__skeleton-text"/>
          <span class="interactive-social-wall__skeleton-actions"/>
        </span>
      </article>
    </template>

    <div v-else-if="!postItems.length" class="interactive-social-wall__empty">
      <i aria-hidden="true" class="uil-comment-alt-lines"/>
      <span>{{ $t('general.no_posts_yet') }}</span>
    </div>

    <template v-else>
      <SocialWallPostItem v-for="postItem in postItems"
                          :key="postItem.key"
                          :post-item="postItem"
                          v-on="$listeners"
      />
    </template>


  </div>
</template>

<script>
import SocialWallPostItem from "./SocialWallPostItem.vue";

export default {
  name: "SocialWallFeed",
  components: {
    SocialWallPostItem,
  },
  props: {
    postItems: {
      type: Array,
      default: () => [],
    },
    isLoaded: {
      type: Boolean,
      default: false,
    },
    loadError: {
      type: String,
      default: "",
    },
    skeletonCount: {
      type: Number,
      default: 6,
    },
  },
};
</script>

<style scoped>
.interactive-social-wall__feed,
.interactive-social-wall__feed * {
  box-sizing: border-box;
}

.interactive-social-wall__feed {
  padding: 0 14px;
}

.interactive-social-wall__feed button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  color: inherit;
  font: inherit;
  line-height: 1;
  cursor: pointer;
  background: transparent;
  border: 0;
  outline: none;
  box-shadow: none;
}

.interactive-social-wall__feed-error {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin: 9px 0 0;
  padding: 7px 9px;
  color: #b84242;
  font-size: 8.5px;
  line-height: 1.4;
  background: #fff5f5;
  border: 1px solid #f2d2d2;
  border-radius: 5px;
}

.interactive-social-wall__feed-error button {
  flex: 0 0 auto;
  min-height: 25px;
  padding: 0 8px !important;
  color: #b84242 !important;
  font-size: 8.5px !important;
  font-weight: 600 !important;
  background: #ffffff !important;
  border: 1px solid #efcaca !important;
  border-radius: 4px;
}

.interactive-social-wall__post {
  display: flex;
  min-height: 86px;
  gap: 14px;
  padding: 10px 0 9px;
  border-bottom: 1px solid #e5e9ef;
}

.interactive-social-wall__post--skeleton {
  align-items: flex-start;
}

.interactive-social-wall__skeleton-avatar,
.interactive-social-wall__skeleton-title,
.interactive-social-wall__skeleton-text,
.interactive-social-wall__skeleton-actions {
  background: linear-gradient(90deg, #f1f3f6 25%, #e7eaf0 50%, #f1f3f6 75%);
  background-size: 200% 100%;
  animation: interactive-social-wall-loading 1.4s ease-in-out infinite;
}

.interactive-social-wall__skeleton-avatar {
  flex: 0 0 36px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
}

.interactive-social-wall__skeleton-content {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 7px;
  padding-top: 2px;
}

.interactive-social-wall__skeleton-title {
  width: 45%;
  height: 11px;
  border-radius: 4px;
}

.interactive-social-wall__skeleton-text {
  width: 70%;
  height: 10px;
  border-radius: 4px;
}

.interactive-social-wall__skeleton-actions {
  width: 58%;
  height: 9px;
  border-radius: 4px;
}

.interactive-social-wall__empty {
  display: flex;
  min-height: 168px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #7a8495;
  font-size: 11px;
}

.interactive-social-wall__empty i {
  color: var(--iconColor);
  font-size: 28px;
}

@keyframes interactive-social-wall-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

@media (max-width: 480px) {
  .interactive-social-wall__feed {
    padding-right: 12px;
    padding-left: 12px;
  }

  .interactive-social-wall__post {
    gap: 10px;
  }
}
</style>
